var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from "vue-property-decorator";
import EditPhotoModal from "@shared/components/EditPhotoModal.vue";
import LoggerService from "@shared/services/logger.service";
import { PhotoType } from "@shared/services/photo-uploader.service";
var TheProfile = /** @class */ (function (_super) {
    __extends(TheProfile, _super);
    function TheProfile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.logger = new LoggerService();
        _this.editPhotoType = PhotoType.Avatar;
        _this.targetElements = null;
        _this.showEditPhotoModal = false;
        _this.emptyImageUrls = [""];
        return _this;
    }
    TheProfile.prototype.showEditAvatarPhotoPopup = function (targetElements, emptyImageUrls) {
        this.targetElements = targetElements;
        this.emptyImageUrls = emptyImageUrls;
        this.showEditPhotoModal = true;
    };
    TheProfile.prototype.mounted = function () {
        global.vueProfile = this;
    };
    TheProfile.prototype.uploadDone = function (imageData) {
        this.showEditPhotoModal = false;
        if (!this.targetElements) {
            return;
        }
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < this.targetElements.length; i++) {
            var element = this.targetElements[i];
            if (imageData) {
                element.style.backgroundImage = "url(\"" + imageData + "\")";
            }
            else {
                var emptyImageUrl = i < this.emptyImageUrls.length ? this.emptyImageUrls[i] : this.emptyImageUrls[this.emptyImageUrls.length - 1];
                element.style.backgroundImage = "url(\"" + emptyImageUrl + "\")";
            }
        }
    };
    TheProfile = __decorate([
        Component({
            components: {
                EditPhotoModal: EditPhotoModal
            },
        })
    ], TheProfile);
    return TheProfile;
}(Vue));
export default TheProfile;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./app/profile/TheProfile.vue
// module id = 158
// module chunks = 4